import { render, staticRenderFns } from "./footermenu.vue?vue&type=template&id=5814e60a&"
import script from "./footermenu.vue?vue&type=script&lang=js&"
export * from "./footermenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports